import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { ResetPinDialogModule } from 'src/app/shared/components/reset-pin-dialog/reset-pin-dialog.module';
import { EnterPinDialogModule } from 'src/app/shared/components/enter-pin-dialog/enter-pin-dialog.module';
import { PinInputModule } from 'src/app/shared/components/pin-input/pin-input.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PendingTransactionDialogComponent } from '../pending-transaction-dialog.component';
import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { BadgeModule } from 'src/app/shared/components/badge/badge.module';
import { AlertModule } from 'src/app/shared/components/alert/alert.module';
import { DropdownModule } from 'src/app/shared/components/dropdown/dropdown.module';
import { AddDrugDialogComponent } from '../../add-drug-dialog/add-drug-dialog.component';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { FormattedDatePipe } from 'src/app/shared/pipes/formatted-date/formatted-date.pipe';
import { FormattedDateModule } from 'src/app/shared/pipes/formatted-date/formatted-date.module';
import { AddNoteModule } from 'src/app/dashboard/components/add-note/add-note.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { DupTransactionsDialogModule } from '../../dup-transactions-dialog/dup-transactions-dialog.module';
import { InventoryLocationsDropdownModule } from 'src/app/shared/components/inventory-locations-dropdown/inventory-locations-dropdown.module';
import { YesNoToggleModule } from 'src/app/shared/components/yes-no-toggle/yes-no-toggle.module';
import { BackCountNotResolvedTooltipModule } from 'src/app/shared/components/back-count-not-resolved-tooltip/back-count-not-resolved-tooltip.module';
import { ErrorMessageModule } from 'src/app/shared/error-message/error-message.module';
import { ValidationService } from '../services/validation.service';



@NgModule({
  declarations: [AddDrugDialogComponent, PendingTransactionDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    PinInputModule,
    EnterPinDialogModule,
    ResetPinDialogModule,
    ButtonModule,
    InputModule,
    ReactiveFormsModule,
    LoaderModule,
    BadgeModule,
    AlertModule,
    DropdownModule,
    InputSearchScannerModule,
    FormattedDateModule,
    AddNoteModule,
    DatepickerInputModule,
    DupTransactionsDialogModule,
    InventoryLocationsDropdownModule,
    YesNoToggleModule,
    BackCountNotResolvedTooltipModule,
    ErrorMessageModule,
  ],
  exports: [AddDrugDialogComponent, PendingTransactionDialogComponent],
  providers: [
    FormattedDatePipe, ValidationService
  ],
})
export class PendingTransactionDialogModule { }
